<ui-grid-col *ngIf="app.routeData.navigation === 'main'" spaced class="m-0 no-print">
	<ui-card widget style="width: 13.75rem; border-radius: 0;">
		<div class="m-nc navigation navigation-main mb-5">
			<table *ngIf="app.org" class="table no-border">

				<!-- Pinned top (Dashboard, Notifications) — sticks while the list scrolls -->
				<tbody class="nav-sticky-top">
					<tr *ngFor="let item of topItems">
						<td class="navigation-link" [ngClass]="{ 'active': isTopLinkActive(item) }">
							<a class="selectable" style="position: relative;" [routerLink]="item.path === 'alert' ? null : ['/' + app.org, item.path]" (click)="item.path === 'alert' && openAlerts()" [appTutorial]="getNavigationTutorialStep(item.path)">
								<img *ngIf="mainIcon(item)" [src]="mainIcon(item)" class="nav-svg-icon mr-2" alt="">
									<i *ngIf="!mainIcon(item) && item.icon" class="{{item.icon}} mr-2"></i>
								<span><span>{{item.description}}</span>
									<div style="right: 8px; top: 25%; padding: 0.4rem;" *ngIf="app.alertCount && item.path === 'alert'" class="badge bg-primary-700 text-white count-badge p-1">{{app.alertCount}}</div>
								</span>
							</a>
						</td>
					</tr>
				</tbody>

				<!-- Order is set in the Customise sidebar popup, so nothing here drags: a menu you navigate
				     with shouldn't move under a stray drag. -->
				<tbody>
					<ng-container *ngFor="let item of mainItems">

						<!-- Plain top-level link -->
						<tr *ngIf="item.type === 'link'">
							<td class="navigation-link" [ngClass]="{ 'active': isTopLinkActive(item) }">
								<a style="position: relative;" [routerLink]="item.path === 'alert' ? null : ['/' + app.org, item.path]" (click)="item.path === 'alert' && openAlerts()" [appTutorial]="getNavigationTutorialStep(item.path)">
									<img *ngIf="mainIcon(item)" [src]="mainIcon(item)" class="nav-svg-icon mr-2" alt="">
									<i *ngIf="!mainIcon(item) && item.icon" class="{{item.icon}} mr-2"></i>
									<span>{{item.description}}</span>
								</a>
							</td>
						</tr>

						<!-- Collapsible group: the header and its expanded children live in one row. -->
						<tr *ngIf="item.type === 'group'" class="nav-no-hover">
							<td class="navigation-group" [ngClass]="{ 'active': isGroupActive(item), 'expanded': isGroupExpanded(item) }">
								<a class="selectable" (click)="toggleGroup(item)">
									<img *ngIf="mainIcon(item)" [src]="mainIcon(item)" class="nav-svg-icon mr-2" alt="">
									<i *ngIf="!mainIcon(item)" class="{{item.icon}} mr-2"></i>
									<span><span>{{item.description}}</span></span>
									<i class="wq chevron" [ngClass]="isGroupExpanded(item) ? 'wq-chevron-up' : 'wq-chevron-down'"></i>
								</a>
								<div *ngIf="isGroupExpanded(item)" class="navigation-group-children">
									<div class="children-inner mt-n2">
										<a *ngFor="let child of item.items; let first = first; let last = last" class="child" [ngClass]="{ 'active': isChildActive(child), 'first': first, 'last': last }" [routerLink]="linkRoute(child)" [appTutorial]="getNavigationTutorialStep(child.path)">
											<span class="p-1" style="position: relative; border-radius: 0.2rem;">{{child.description}}
												<span class="nav-child-count badge bg-silver-15 p-1 text-secondary" *ngIf="billableTaskCount && child.path === 'sales-order/billing' && app.orgInfo?.allow_work_hub">{{billableTaskCount}}</span>
												<span class="nav-child-count badge bg-silver-15 p-1 text-secondary" *ngIf="followupTaskCount && child.path === 'task/followup' && app.orgInfo?.allow_work_hub">{{followupTaskCount}}</span>
												<span class="nav-child-count badge bg-silver-15 p-1 text-secondary" *ngIf="requestsToApproveCount && child.path === 'purchase/approve' && app.orgInfo?.allow_procurement">{{requestsToApproveCount}}</span>
												<span class="nav-child-count badge bg-silver-15 p-1 text-secondary" *ngIf="crmOpenDealCount && child.path === 'crm/deals' && app.orgInfo?.allow_crm">{{crmOpenDealCount}}</span>
											</span>
										</a>
									</div>
								</div>
							</td>
						</tr>

					</ng-container>
				</tbody>

				<!-- Pinned footer (Discover) -->
				<tbody>
					<ng-container *ngFor="let item of footerItems">
						<tr *ngIf="item.type === 'header'">
							<td class="navigation-header">
								{{item.description}}
							</td>
						</tr>
						<tr *ngIf="item.type === 'link'">
							<td class="navigation-link" [ngClass]="{ 'active': isTopLinkActive(item) }">
								<a style="position: relative;" [routerLink]="linkRoute(item)" [appTutorial]="getNavigationTutorialStep(item.path)">
									<img *ngIf="mainIcon(item)" [src]="mainIcon(item)" class="nav-svg-icon mr-2" alt="">
									<i *ngIf="!mainIcon(item) && item.icon" class="{{item.icon}} mr-2"></i>
									<span>
										<span>{{item.description}}</span>
										<div style="right: 8px; top: 25%; padding: 0.4rem;" *ngIf="isOnboardingNew && item.path === 'onboarding-progress'" class="badge badge-primary-700 count-badge p-1">New</div>
									</span>
								</a>
							</td>
						</tr>
					</ng-container>

					<!-- The only place the menu order changes. Offered to members of the organisation, the same
					     as the order itself, which is saved per user. -->
					<tr *ngIf="canReorder">
						<td class="navigation-link">
							<a class="selectable" (click)="customiseSidebar()">
								<i class="wq wq-configure mr-2"></i>
								<span><span>Customise workspace</span></span>
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</ui-card>
</ui-grid-col>

<ui-grid-col *ngIf="app.routeData.navigation === 'settings'" spaced class="m-0 no-print">
	<ui-card widget style="width: 13.75rem; border-radius: 0;">
		<div class="m-nc navigation mb-5">
			<table *ngIf="app.org" class="table no-border">
				<tbody>
					<tr>
						<td class="navigation-link">
							<a [routerLink]="['/' + app.org]">
								<i class="wq wq-chevron-left mr-2"></i>
								<span><span>Back to WeQuote</span></span>
							</a>
						</td>
					</tr>

					<ng-container *ngFor="let item of getNavigation('settings')">
						<tr *ngIf="item.type === 'header'">
							<td class="navigation-header">
								{{item.description}}
							</td>
						</tr>

						<!-- Plain link -->
						<tr *ngIf="item.type === 'link' && !(item.items && item.items.length > 1)">
							<td class="navigation-link" [ngClass]="{ 'active': isPathSelected(item.path) }">
								<a [routerLink]="['/' + app.org, 'settings', item.path]">
									<i class="{{item.icon}} mr-2"></i>
									<span><span>{{item.description}}</span></span>
								</a>
							</td>
						</tr>

						<!-- Expandable group -->
						<ng-container *ngIf="item.type === 'link' && item.items && item.items.length > 1">
							<tr class="nav-no-hover">
								<td class="navigation-group" [ngClass]="{ 'active': isPathSelected(item.path), 'expanded': isSubNavExpanded(item) }">
									<a class="selectable" (click)="toggleSubNav(item)">
										<i class="{{item.icon}} mr-2"></i>
										<span><span>{{item.description}}</span></span>
										<i class="wq chevron" [ngClass]="isSubNavExpanded(item) ? 'wq-chevron-up' : 'wq-chevron-down'"></i>
									</a>
								</td>
							</tr>
							<tr *ngIf="isSubNavExpanded(item)" class="nav-no-hover">
								<td class="navigation-group-children">
									<div class="children-inner">
										<a *ngFor="let subitem of item.items; let last = last" class="child" [ngClass]="{ 'active': isSubItemActive(item, subitem), 'last': last }" [routerLink]="subitem.path ? ['/' + app.org, 'settings', item.path, subitem.path] : ['/' + app.org, 'settings', item.path]">
											<span class="p-1" style="position: relative; border-radius: 0.2rem;">{{subitem.description}}</span>
										</a>
									</div>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>
	</ui-card>
</ui-grid-col>

<ui-grid-col *ngIf="app.routeData.navigation === 'customer-portal'" spaced class="m-0 no-print">
	<ui-card widget style="width: 13.75rem; border-radius: 0;">
		<div class="m-nc navigation mb-5">
			<table *ngIf="app.org" class="table no-border">
				<tbody>
					<tr>
						<td class="navigation-link">
							<a [routerLink]="['/' + app.org]">
								<i class="wq wq-chevron-left mr-2"></i>
								<span><span>Back to WeQuote</span></span>
							</a>
						</td>
					</tr>

					<ng-container *ngFor="let item of getNavigation('customer-portal')">
						<tr *ngIf="item.type === 'header'">
							<td class="navigation-header">
								{{item.description}}
							</td>
						</tr>

						<!-- Plain link -->
						<tr *ngIf="item.type === 'link' && !(item.items && item.items.length > 1)">
							<td class="navigation-link" [ngClass]="{ 'active': isPathSelected(item.path) }">
								<a [routerLink]="['/' + app.org, 'customer-portal', item.path]">
									<i class="{{item.icon}} mr-2"></i>
									<span><span>{{item.description}}</span></span>
								</a>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</ui-card>
</ui-grid-col>


<ui-grid-col *ngIf="app.routeData.navigation === 'purchase' && app.orgInfo?.allow_procurement" spaced class="m-0 no-print">
	<ui-card widget style="width: 13.75rem; border-radius: 0;">
		<div class="m-nc navigation mb-5">
			<table *ngIf="app.org" class="table no-border">
				<tbody>
					<tr>
						<td class="navigation-link">
							<a [routerLink]="['/' + app.org]">
								<i class="wq wq-chevron-left mr-2"></i>
								<span><span>Back to WeQuote</span></span>
							</a>
						</td>
					</tr>
					<ng-container *ngFor="let item of getNavigation('purchase')">
						<tr *ngIf="item.type === 'header'">
							<td class="navigation-header">
								{{item.description}}
							</td>
						</tr>
						<!-- Plain link -->
						<tr *ngIf="item.type === 'link' && !(item.items && item.items.length > 1)">
							<td class="navigation-link" [ngClass]="{ 'active': isPathSelected(item.path) }">
								<a style="position: relative;" [routerLink]="item.absolute ? ['/' + app.org, item.path]: ['/' + app.org, 'purchase', item.path]">
									<i class="{{item.icon}} mr-2"></i>
									<span>{{item.description}}</span>
								</a>
							</td>
						</tr>

						<!-- Expandable group -->
						<ng-container *ngIf="item.type === 'link' && item.items && item.items.length > 1">
							<tr class="nav-no-hover">
								<td class="navigation-group" [ngClass]="{ 'active': isPathSelected(item.path), 'expanded': isSubNavExpanded(item) }">
									<a class="selectable" (click)="toggleSubNav(item)">
										<i class="{{item.icon}} mr-2"></i>
										<span><span>{{item.description}}</span></span>
										<i class="wq chevron" [ngClass]="isSubNavExpanded(item) ? 'wq-chevron-up' : 'wq-chevron-down'"></i>
									</a>
								</td>
							</tr>
							<tr *ngIf="isSubNavExpanded(item)" class="nav-no-hover">
								<td class="navigation-group-children">
									<div class="children-inner">
										<a *ngFor="let subitem of item.items; let last = last" class="child" [ngClass]="{ 'active': isSubItemActive(item, subitem), 'last': last }" [routerLink]="subitem.path ? ['/' + app.org, 'purchase', item.path, subitem.path] : ['/' + app.org, 'purchase', item.path]">
											<span class="p-1" style="position: relative; border-radius: 0.2rem;">{{subitem.description}}
												<span class="nav-child-count badge bg-silver-15 p-1 text-secondary" *ngIf="requestsToApproveCount && item.path === 'approve' && subitem.path === '' && app.orgInfo?.allow_procurement">{{requestsToApproveCount}}</span>
											</span>
										</a>
									</div>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>
	</ui-card>
</ui-grid-col>

<ui-grid-col *ngIf="app.routeData.navigation === 'warehouse' && app.orgInfo?.allow_procurement" spaced class="m-0 no-print">
	<ui-card widget style="width: 13.75rem; border-radius: 0;">
		<div class="m-nc navigation mb-5">
			<table *ngIf="app.org" class="table no-border">
				<tbody>
					<tr>
						<td class="navigation-link">
							<a [routerLink]="['/' + app.org]">
								<i class="wq wq-chevron-left mr-2"></i>
								<span><span>Back to WeQuote</span></span>
							</a>
						</td>
					</tr>
					<ng-container *ngFor="let item of getNavigation('warehouse')">
						<tr *ngIf="item.type === 'header'">
							<td class="navigation-header">
								{{item.id === 1 ? (warehouseService.warehouseName || '&nbsp;') : item.description}}
							</td>
						</tr>
						<ng-container *ngIf="item.path === 'list' || item.path === 'overview' || item.path === 'purchase' || item.path === 'scanners' || item.path === 'guide' || warehouseService.warehouseId">

							<!-- Plain link -->
							<tr *ngIf="item.type === 'link' && !(item.items && item.items.length > 1)">
								<td class="navigation-link" [ngClass]="{ 'active': isPathSelected(item.path) }">
									<a [routerLink]="item.absolute ? ['/' + app.org, item.path] : (item.path === 'list' || item.path === 'overview' || item.path === 'scanners' || item.path === 'guide') ? ['/' + app.org, 'warehouse', item.path] : ['/' + app.org, 'warehouse', warehouseService.warehouseId, item.path]">
										<i class="{{item.icon}} mr-2"></i>
										<span><span>{{item.description}}</span></span>
									</a>
								</td>
							</tr>

							<!-- Expandable group -->
							<ng-container *ngIf="item.type === 'link' && item.items && item.items.length > 1">
								<tr class="nav-no-hover">
									<td class="navigation-group" [ngClass]="{ 'active': isPathSelected(item.path), 'expanded': isSubNavExpanded(item) }">
										<a class="selectable" (click)="toggleSubNav(item)">
											<i class="{{item.icon}} mr-2"></i>
											<span><span>{{item.description}}</span></span>
											<i class="wq chevron" [ngClass]="isSubNavExpanded(item) ? 'wq-chevron-up' : 'wq-chevron-down'"></i>
										</a>
									</td>
								</tr>
								<tr *ngIf="isSubNavExpanded(item)" class="nav-no-hover">
									<td class="navigation-group-children">
										<div class="children-inner">
											<ng-container *ngFor="let subitem of item.items; let last = last">
												<a *ngIf="item.path === 'list' || item.path === 'scanners'" class="child" [ngClass]="{ 'active': isSubItemActive(item, subitem), 'last': last }" [routerLink]="subitem.path ? ['/' + app.org, 'warehouse', item.path, subitem.path] : ['/' + app.org, 'warehouse', item.path]">
													<span class="p-1" style="position: relative; border-radius: 0.2rem;">{{subitem.description}}</span>
												</a>
												<a *ngIf="item.path !== 'list' && item.path !== 'scanners'" class="child" [ngClass]="{ 'active': isSubItemActive(item, subitem), 'last': last }" [routerLink]="subitem.path ? ['/' + app.org, 'warehouse', warehouseService.warehouseId, item.path, subitem.path] : ['/' + app.org, 'warehouse', warehouseService.warehouseId, item.path]">
													<span class="p-1" style="position: relative; border-radius: 0.2rem;">{{subitem.description}}</span>
												</a>
											</ng-container>
										</div>
									</td>
								</tr>
							</ng-container>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>
	</ui-card>
</ui-grid-col>

<ui-grid-col *ngIf="app.routeData.module === 'quote' && app.routeData.navigation === 'quote'" spaced class="m-0 no-print">
	<ui-card widget style="width: 5.625rem; border-radius: 0;">
		<div *ngIf="app.org" class="mx-n2 d-flex flex-column mb-5">
			<ng-container *ngFor="let item of getNavigation('quote'); let last;">
				<a *ngIf="item.path" class="py-2 text-center" [routerLink]="['/' + app.org, 'quote', app.routeParams.quote, item.path]" [replaceUrl]="true" (mouseenter)="hover = item" (mouseleave)="hover = null" [appTutorial]="getQuoteTutorialStep(item.path)">
					<i class="{{item.icon}} h1" [ngClass]="{ 'text-primary': hover === item || app.routeData.path === item.path, 'text-muted': !(hover === item || app.routeData.path === item.path) }"></i><br>
					<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === item || app.routeData.path === item.path, 'text-dark': !(hover === item || app.routeData.path === item.path) }">{{item.description}}</span>
				</a>
			</ng-container>
			<a *ngIf="app.routeParams.quote" class="py-2 text-center selectable position-relative" (mouseenter)="hover = 'notes'" (mouseleave)="hover = null" (click)="openQuoteNotes()">
				<i class="wq wq-notes h1" [ngClass]="{ 'text-primary': hover === 'notes', 'text-muted': hover !== 'notes' }"></i><br>
				<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === 'notes', 'text-dark': hover !== 'notes' }">Notes and Documents</span>
				<span *ngIf="quoteNoteCount" class="badge badge-primary count-badge p-1 rounded-circle">{{quoteNoteCount}}</span>
			</a>
		</div>
	</ui-card>
</ui-grid-col>

<ui-grid-col *ngIf="app.routeData.module === 'sales-order' && app.routeData.navigation === 'quote'" spaced class="m-0 no-print">
	<ui-card widget style="width: 5.625rem; border-radius: 0;">
		<div *ngIf="app.org" class="mx-n2 d-flex flex-column mb-5">
			<ng-container *ngFor="let item of getNavigation('sales-order'); let last;">
				<a *ngIf="item.path" class="py-2 text-center" [routerLink]="['/' + app.org, 'sales-order', app.routeParams.quote, item.path]" [replaceUrl]="true" (mouseenter)="hover = item" (mouseleave)="hover = null" [appTutorial]="getQuoteTutorialStep(item.path)">
					<i class="{{item.icon}} h1" [ngClass]="{ 'text-primary': hover === item || app.routeData.path === item.path, 'text-muted': !(hover === item || app.routeData.path === item.path) }"></i><br>
					<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === item || app.routeData.path === item.path, 'text-dark': !(hover === item || app.routeData.path === item.path) }">{{item.description}}</span>
				</a>
			</ng-container>
			<a *ngIf="app.routeParams.quote" class="py-2 text-center selectable position-relative" (mouseenter)="hover = 'notes'" (mouseleave)="hover = null" (click)="openQuoteNotes()">
				<i class="wq wq-notes h1" [ngClass]="{ 'text-primary': hover === 'notes', 'text-muted': hover !== 'notes' }"></i><br>
				<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === 'notes', 'text-dark': hover !== 'notes' }">Notes and Documents</span>
				<span *ngIf="quoteNoteCount" class="badge badge-primary count-badge p-1 rounded-circle">{{quoteNoteCount}}</span>
			</a>
			<a *ngIf="app.routeParams.quote && showInvoicing" class="py-2 text-center selectable position-relative" (mouseenter)="hover = 'invoicing'" (mouseleave)="hover = null" (click)="openQuoteInvoicing()">
				<i class="wq wq-card h1" [ngClass]="{ 'text-primary': hover === 'invoicing', 'text-muted': hover !== 'invoicing' }"></i><br>
				<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === 'invoicing', 'text-dark': hover !== 'invoicing' }">Invoicing</span>
			</a>
		</div>
	</ui-card>
</ui-grid-col>

<ui-grid-col *ngIf="app.routeData.navigation === 'project'" spaced class="m-0 no-print">
	<ui-card widget style="width: 5.625rem; border-radius: 0;">
		<div *ngIf="app.org" class="mx-n2 d-flex flex-column mb-5">
			<ng-container *ngFor="let item of getNavigation('project'); let last;">
				<a *ngIf="item.path" class="py-2 text-center" [routerLink]="['/' + app.org, 'project', app.routeParams.project, item.path]" [replaceUrl]="true" (mouseenter)="hover = item" (mouseleave)="hover = null">
					<i class="{{item.icon}} h1" [ngClass]="{ 'text-primary': hover === item || app.routeData.path === item.path, 'text-muted': !(hover === item || app.routeData.path === item.path) }"></i><br>
					<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === item || app.routeData.path === item.path, 'text-dark': !(hover === item || app.routeData.path === item.path) }">{{item.description}}</span>
				</a>
			</ng-container>
			<a *ngIf="app.routeParams.project" class="py-2 text-center selectable position-relative" (mouseenter)="hover = 'exporter'" (mouseleave)="hover = null" (click)="openProjectExporter()">
				<i class="wq wq-export h1" [ngClass]="{ 'text-primary': hover === 'exporter', 'text-muted': hover !== 'exporter' }"></i><br>
				<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === 'exporter', 'text-dark': hover !== 'exporter' }">Export</span>
			</a>
			<a *ngIf="app.routeParams.project" class="py-2 text-center selectable position-relative" (mouseenter)="hover = 'notes'" (mouseleave)="hover = null" (click)="openProjectNotes()">
				<i class="wq wq-notes h1" [ngClass]="{ 'text-primary': hover === 'notes', 'text-muted': hover !== 'notes' }"></i><br>
				<span class="d-inline-block text-tiny mt-2" [ngClass]="{ 'text-primary': hover === 'notes', 'text-dark': hover !== 'notes' }">Notes and Documents</span>
				<span *ngIf="projectNoteCount" class="badge badge-primary count-badge p-1 rounded-circle">{{projectNoteCount}}</span>
			</a>
		</div>
	</ui-card>
</ui-grid-col>

<modal-activity-log></modal-activity-log>
<modal-customise-sidebar (close)="onSidebarCustomised($event)"></modal-customise-sidebar>
<modal-project-exporter></modal-project-exporter>
<modal-quote-choose-project *ngIf="app.routeParams.quote" (close)="chooseProjectModalClosed($event)"></modal-quote-choose-project>
<modal-alert-inbox></modal-alert-inbox>
